import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from './api';
import type { AuthClient } from './auth';
import type { RuntimeConfig } from './config';

export interface AppServices {
  config: RuntimeConfig;
  auth: AuthClient;
  api: ApiClient;
}

const Ctx = createContext<AppServices | null>(null);

export function ServicesProvider({ value, children }: { value: AppServices; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useServices(): AppServices {
  const v = useContext(Ctx);
  if (!v) throw new Error('ServicesProvider missing');
  return v;
}
